import { render, staticRenderFns } from "./RadioPrefetch.vue?vue&type=template&id=2415aad1&"
import script from "./RadioPrefetch.vue?vue&type=script&lang=js&"
export * from "./RadioPrefetch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports